import {Pipe, PipeTransform} from '@angular/core';
import {FaqPageDetailDto} from '../../domain/faq/faqNodeDetailDto';

@Pipe({
    name: 'faqMailSubject'
})
export class FaqMailSubjectPipe implements PipeTransform {

    constructor() {
    }

    transform(faqPage: FaqPageDetailDto, separator: string = '|'): string {
        // slice(1) to skip root folder FAQ
        return faqPage.ancestors.slice(1)
            .map(faqNode => `${faqNode.title} ${separator} `).join('') + faqPage.title;
    }
}
